import { render, staticRenderFns } from "./order-assign.vue?vue&type=template&id=7e7b6b73&"
import script from "./order-assign.vue?vue&type=script&lang=js&"
export * from "./order-assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports